/* IBM Confidential‌ - OCO Source Materials‌ - (C) COPYRIGHT IBM CORP. 2021-2024 - The source code for this program is not published or otherwise‌ divested of its trade secrets, irrespective of what has been‌ deposited with the U.S. Copyright Office. */

import messages from "./messages/messages.json";
import {
  getTriAppConfig,
} from "@tririga/tririga-react-components/es/TriAppConfig";
import {
  getTranslatedMessages,
} from "@tririga/tririga-react-components/es/TriDictionary";

const VERSION = process.env.REACT_APP_VERSION;
const DEFAULT_USER_LANGUAGE_ID = 1;

const baseMessages = {
  ...messages,
};

let appMessages = null;
let appMessagesLanguageId = DEFAULT_USER_LANGUAGE_ID;

export const APP_LOG_IN_TO = "APP_LOG_IN_TO";
export const APP_ADMIN_CONSOLE = "APP_ADMIN_CONSOLE";
export const APP_USERNAME = "APP_USERNAME";
export const APP_ENTER_USERNAME = "APP_ENTER_USERNAME";
export const APP_PASSWORD = "APP_PASSWORD";
export const APP_ENTER_PASSWORD = "APP_ENTER_PASSWORD";
export const APP_OLD_PASSWORD = "APP_OLD_PASSWORD";
export const APP_ENTER_OLD_PASSWORD = "APP_ENTER_OLD_PASSWORD";
export const APP_NEW_PASSWORD = "APP_NEW_PASSWORD";
export const APP_ENTER_NEW_PASSWORD = "APP_ENTER_NEW_PASSWORD";
export const APP_CONFIRM_NEW_PASSWORD = "APP_CONFIRM_NEW_PASSWORD";
export const APP_ENTER_CONFIRM_NEW_PASSWORD = "APP_ENTER_CONFIRM_NEW_PASSWORD";
export const APP_CONTINUE = "APP_CONTINUE";
export const APP_LOG_IN = "APP_LOG_IN";
export const APP_INVALID_USERNAME_PASSWORD = "APP_INVALID_USERNAME_PASSWORD";
export const APP_ENTER_VALID_USERNAME_PASSWORD = "APP_ENTER_VALID_USERNAME_PASSWORD";
export const APP_PASSWORD_CHANGE_REQUIRED = "APP_PASSWORD_CHANGE_REQUIRED";
export const APP_PASSWORD_CHANGE_SUCCESSFUL = "APP_PASSWORD_CHANGE_SUCCESSFUL";
export const APP_ERROR = "APP_ERROR";
export const APP_ERROR_INVALID_EMAIL = "APP_ERROR_INVALID_EMAIL";
export const APP_ERROR_EMAIL_NOT_SENT = "APP_ERROR_EMAIL_NOT_SENT";
export const APP_ERROR_INVALID_USERNAME_PASSWORD = "APP_ERROR_INVALID_USERNAME_PASSWORD";
export const APP_ERROR_NOT_ALLOWED = "APP_ERROR_NOT_ALLOWED";
export const APP_SUCCESS = "APP_SUCCESS";
export const APP_SYSTEM_ERROR = "APP_SYSTEM_ERROR";
export const APP_SYSTEM_ERROR_PWD = "APP_SYSTEM_ERROR_PWD";
export const APP_SYSTEM_ERROR_EMAIL = "APP_SYSTEM_ERROR_EMAIL";
export const APP_SYSTEM_ERROR_EMAIL_EXCEEDED_LIMIT = "APP_SYSTEM_ERROR_EMAIL_EXCEEDED_LIMIT";
export const APP_PWD_RULES_CONSIST_OF = "APP_PWD_RULES_CONSIST_OF";
export const APP_PWD_RULES_OPTIONAL_CONSIST_OF = "APP_PWD_RULES_OPTIONAL_CONSIST_OF";
export const APP_PWD_RULE_HISTORY_COUNT = "APP_PWD_RULE_HISTORY_COUNT";
export const APP_PWD_RULE_HISTORY_PREVIOUS = "APP_PWD_RULE_HISTORY_PREVIOUS";
export const APP_PWD_RULE_NOT_SAME_AS_PREVIOUS = "APP_PWD_RULE_NOT_SAME_AS_PREVIOUS";
export const APP_PWD_RULE_MIN_CHARS = "APP_PWD_RULE_MIN_CHARS";
export const APP_PWD_RULE_MAX_CHARS = "APP_PWD_RULE_MAX_CHARS";
export const APP_PWD_RULE_MIN_MAX_CHARS = "APP_PWD_RULE_MIN_MAX_CHARS";
export const APP_PWD_RULE_LOWERCASE_REQ = "APP_PWD_RULE_LOWERCASE_REQ";
export const APP_PWD_RULE_LOWERCASE_OPTIONAL = "APP_PWD_RULE_LOWERCASE_OPTIONAL";
export const APP_PWD_RULE_UPPERCASE_REQ = "APP_PWD_RULE_UPPERCASE_REQ";
export const APP_PWD_RULE_UPPERCASE_OPTIONAL = "APP_PWD_RULE_UPPERCASE_OPTIONAL";
export const APP_PWD_RULE_NUMBER_REQ = "APP_PWD_RULE_NUMBER_REQ";
export const APP_PWD_RULE_NUMBER_OPTIONAL = "APP_PWD_RULE_NUMBER_OPTIONAL";
export const APP_PWD_RULE_SPECIAL_REQ = "APP_PWD_RULE_SPECIAL_REQ";
export const APP_PWD_RULE_SPECIAL_OPTIONAL = "APP_PWD_RULE_SPECIAL_OPTIONAL";
export const APP_PWD_RULE_NOT_CONTAIN_USERNAME = "APP_PWD_RULE_NOT_CONTAIN_USERNAME";
export const APP_ERROR_NEW_PASSWORD_NO_MATCH = "APP_ERROR_NEW_PASSWORD_NO_MATCH";
export const APP_ERROR_PASSWORD_RULES_NOT_MET = "APP_ERROR_PASSWORD_RULES_NOT_MET";
export const APP_CREATE_NEW_PASSWORD = "APP_CREATE_NEW_PASSWORD";
export const APP_LOGGIN_IN_AS_MSG = "APP_LOGGIN_IN_AS_MSG";
export const APP_NOT_CURRENT_USER = "APP_NOT_CURRENT_USER";
export const APP_CREATE_NEW_PASSWORD_MSG = "APP_CREATE_NEW_PASSWORD_MSG";
export const APP_FORGOT_PASSWORD = "APP_FORGOT_PASSWORD";
export const APP_HAVING_TROUBLE_LOGGING_IN = "APP_HAVING_TROUBLE_LOGGING_IN";
export const APP_HAVING_TROUBLE_LOGGING_IN_MSG = "APP_HAVING_TROUBLE_LOGGING_IN_MSG";
export const APP_EMAIL_ADDRESS = "APP_EMAIL_ADDRESS";
export const APP_ENTER_EMAIL_ADDRESS = "APP_ENTER_EMAIL_ADDRESS";
export const APP_INVALID_EMAIL_ADDRESS = "APP_INVALID_EMAIL_ADDRESS";
export const APP_TEMPORARY_PASSWORD_SENT = "APP_TEMPORARY_PASSWORD_SENT";
export const APP_TEMPORARY_PASSWORD_SENT_MSG = "APP_TEMPORARY_PASSWORD_SENT_MSG";
export const APP_BACK_TO_LOGIN = "APP_BACK_TO_LOGIN";

export function getMessage(label) {
  return appMessages[label];
}

export async function initMessages(userLanguageId = DEFAULT_USER_LANGUAGE_ID) {
  if (process.env.NODE_ENV==='development') {
      appMessages = baseMessages;
  } else if (!appMessages || appMessagesLanguageId !==userLanguageId) {
    try {
      appMessages = await getTranslatedMessages(
        baseMessages,
        getTriAppConfig().appExposedName + VERSION,
        Number(userLanguageId)
      );
      appMessagesLanguageId = userLanguageId;
      
      localStorage.setItem("triPlatformLoginMessages",JSON.stringify(appMessages));
    } catch (error) {
      alert(
        'Unable to get translations, defaulting to English -' + error
      );
      appMessages = baseMessages;
      appMessagesLanguageId = DEFAULT_USER_LANGUAGE_ID;
    }
  }
}